
(() => {
  function initHeroSliders() {
    document.querySelectorAll('.js-hero-swiper').forEach((slider) => {
      if (slider.swiper) return;

      const loop = slider.dataset.loop === 'true';
      const autoplay = slider.dataset.autoplay === 'true';
      const delay = parseInt(slider.dataset.delay || 5000, 10);
      const speed = parseInt(slider.dataset.speed || 800, 10);
      const effect = slider.dataset.effect || 'slide';

      new Swiper(slider, {
        loop: loop,
        speed: speed,
        effect: effect,

        autoplay: autoplay ? {
          delay: delay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,

        pagination: slider.querySelector('.swiper-pagination') ? {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        } : false,

        navigation: slider.querySelector('.swiper-button-next') ? {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        } : false,

        fadeEffect: {
          crossFade: true
        },

        observer: true,
        observeParents: true,
        watchOverflow: true
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHeroSliders);
  document.addEventListener('shopify:section:load', initHeroSliders);
})();
